import axios from 'axios';
import auth from './auth';

let API_URL = 'https://api.escapeitkit.com:443/api/';
if (location.hostname === 'localhost') {
    API_URL = 'http://localhost:9000/api/';
}

export default {
    createRoom: function(title, build_id) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'rooms', {title: title, build_id: build_id}, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },
    getRooms: function() {
        return new Promise((resolve, reject) => {
            axios.get(API_URL + 'rooms', {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            });
        });
    },
    getRoom: function(room_id) {
        return new Promise((resolve, reject) => {
            axios.get(API_URL + 'rooms/' + room_id, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data)
            });
        });
    },
    getRoomByCode: function(room_code) {
        return new Promise((resolve, reject) => {
            axios.get(API_URL + 'rooms/code/' + room_code).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data)
            });
        });
    },
    // update: function(room_id, payload) {
    //     return new Promise((resolve, reject) => {
    //         axious.put(API_URL + 'rooms/' + room_id, payload, {headers: auth.getAuthHeader()}).then(response => {
    //             resolve(response.data);
    //         }, err => {
    //             reject(err.response.data);
    //         })
    //     });
    // },
    setRemaining: function(room_id, remaining) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'rooms/timer', {room_id: room_id, remaining: remaining}, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            })
        });
    },
    setStatus: function(room_id, status) {
        return new Promise((resolve, reject) => {
            axios.post(API_URL + 'rooms/status', {room_id: room_id, status: status}, {headers: auth.getAuthHeader()}).then(response => {
                resolve(response.data);
            }, err => {
                reject(err.response.data);
            })
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/rooms.js